export default {
  homeLink: {
    elitego: "Elitego Allot",
    aboutLink: "ABOUT US",
    workLink: "WORK WITH US",
    resourceLink: "RESOURCE",
    contactLink: "CONTACT US",
  },
  homeAbout: {
    title: "Elitego Allot：Headhunting Cooperation Platform",
    briefIntroduction:
      "Elitego Allot, wholly owned by Elitego Talent, is a headhunting cooperation platform aim to integrate cross-border demand & supply in the executive search industry. We provide a one-stop solution to global search firms and freelance recruiters in solving difficulties in business development, client management and case delivery in China. With technical support and business resource from parent company, we are able to connect entrepreneurs and senior executives of employers to ensure all job openings are timely and accurate. Currently, we are working with hundreds of employers including tech giants, Fortune 500's, state-owned enterprises, large conglomerates as well as foreign companies in China.",
    structure: "SIX SERVICES",
    post: "Job Openings",
    operation: "Platform Operation",
    information: "Information Sharing",
    communicate: "Client Communication",
    training: "Professional Training",
    consultant: "Exclusive Consultant",
  },
  homeWork: {
    title: "Cooperation SOP",
    stepNameOne: "Agreement Signing",
    stepNameTwo: "Project Selection",
    stepNameThree: "Candidate Recommendation",
    stepNameFour: "Interview Arrangement",
    stepNameFive: "Offer Negotiation",
    stepNameSix: "Profit Sharing",
    stepContentOne: "Establish formal partnership with Elitego Allot",
    stepContentTwo: "Choose and work on preferred mandates",
    stepContentThree:
      "Present suitable candidates to employers through Elitego Allot",
    stepContentFour: "Arrange interviews between candidates and employers",
    stepContentFive:
      "Assist both sides in reaching agreement on employment terms",
    stepContentSix: "Collect and share profit after candidate is on-board",
  },
  homeResource: {
    title: "Job Openings",
    one: "AI Application System Architect",
    two: "Automation Engineer",
    three: "Machine Learning System Development Engineer",
    four: "AIoT Developer tools lead",
    five: "Decision Optimization Algorithm Engineer",
    six: "Speech Recognition Algorithm Engineer",
    seven: "NLP Large Model Algorithm Engineer",
    eight: "Recommendation System Architect",
    nine: "Search Recommendation Product Expert",
    ten: "AI Modeling Engineer",
    eleven: "Intelligent Application Development Engineer",
    twelve: "Data Annotation Team Leader",
    thirteen: "Open Source Algorithm Researcher",
    fourteen: "Data Modeling Engineer",
    fifteen: "Autonomous Driving Algorithm Engineer",
    sixteen: "Motion Control Algorithm Engineer",
    seventeen: "Technical Project Management Leader",
    eighteen: "Robot Development Expert",
    nineteen: "Fusion Positioning Algorithm Expert",
    twenty: "······",

    twentyOne: "CTO",
    twentyTwo: "Business Vice President",
    twentyThree: "Doctoral Expert",
    twentyFour: "AI Algorithm Engineer",
    twentyFive: "Database Engineer",
    twentySix: "3D Vision Algorithm Engineer",
    twentySeven: "Embedded Senior R&D Engineer",
    twentyEight: "Gateway Meter Chief Expert",
    twentyNine: "Data Analyst",
    thirty: "Machine Vision Algorithm Engineer",
    thirtyOne: "HRD (Human Resources Director)",
    thirtyTwo: "Data Scientist",
    thirtyThree: "R&D Supervisor",
    thirtyFour: "Product Owner",
    thirtyFive: "Solution Engineer Project",
    thirtySix: "Manager Architect",
    thirtySeven: "R&D Manager",

    thirtyEight: "MES Leader",
    thirtyNine: "Digital Transformation Leader",
    forty: "Reinforcement Learning Algorithm Engineer",
    fortyOne: "Big Data Architect",
    fortyTwo: "Doctoral Expert",
    fortyThree: "Senior Technical Advisor",
    fortyFour: "Database Kernel Development Expert",
    fortyFive: "RPA Business Unit Leader",
    fortySix: "Chief Information Officer",
    fortySeven: "Digital Manager",
    fortyEight: "AI Product Manager",
    fortyNine: "Unity3D Engineer",
    fifty: "Embedded Software Engineer",
    fiftyOne: "Simulation Engineer",
    fiftyTwo: "Deep Learning Algorithm Engineer",
    fiftyThree: "Senior Cloud Container Engineer",
    fiftyFour: "Natural Language Processing Algorithm Engineer",
    fiftyFive: "Senior Full-stack Engineer",
    fiftySix: "Senior Web System Development Engineer",
  },
  homeFooter: {
    addressOne:
      "Our address: Room 1601, Building 1, Juheng Science and Technology Park, No. 20, Yueyuan Road, Yuehu Street, Kaifu District, Changsha City, Hunan Province, China",
    branchAddress: "",
    contentOne: "Contact Us",
    contentTwo: "WeChat Official Accounts",
    record:
      "Copyright © 2025 Hunan Elitego Talent Technology Co., Ltd. All rights reserved.",
  },
};
